import SiteHeader from "@/components/common/SiteHeader";
import { createFileRoute } from "@tanstack/react-router";
import React, { Suspense, lazy } from "react";

// Wave-17 Item 1.1 — Settings page lazy-loaded.
const Settings = lazy(() => import("@/pages/Settings/Page"));

const SettingsRoute = () => (
  <div className="flex flex-col w-full">
    <SiteHeader header="Settings" />
    <Suspense fallback={null}>
      <Settings />
    </Suspense>
  </div>
);

export const Route = createFileRoute("/settings")({
  component: SettingsRoute,
});
